export default "__VITE_ASSET__CPE2re3u__"